module.exports = __webpack_public_path__ + "static/img/1970_phase_function_Paper_PointsHejduk_Prediction.c16e698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1970_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jmVh
// module chunks = 0